import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import { countries } from "../../../Api/CountriesList";

export default function AddressDetails({
  addressDetails,
  handleSetAddressDetails,
}) {
  useEffect(() => {
    if (
      addressDetails.StreetAddress !== "" &&
      addressDetails.City !== "" &&
      addressDetails.State !== "" &&
      addressDetails.Country !== ""
    ) {
      handleSetAddressDetails({ ...addressDetails, AllOk: true });
    } else {
      handleSetAddressDetails({ ...addressDetails, AllOk: false });
    }
  }, [
    addressDetails.StreetAddress,
    addressDetails.City,
    addressDetails.State,
    addressDetails.Country,
  ]);

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Address Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            id="WebsiteAddress"
            label="WebsiteAddress"
            fullWidth
            value={addressDetails.WebsiteAddress}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                WebsiteAddress: e.target.value,
              })
            }
            autoComplete="WebsiteAddress"
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="StreetAddress"
            label="Street Address"
            fullWidth
            value={addressDetails.StreetAddress}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                StreetAddress: e.target.value,
              })
            }
            autoComplete="StreetAddress"
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="Town/Village"
            label="Town / Village"
            fullWidth
            autoComplete="Town/Village"
            variant="standard"
            value={addressDetails.Town}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                Town: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="City"
            label="City"
            fullWidth
            autoComplete="City"
            variant="standard"
            value={addressDetails.City}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                City: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            required
            id="State"
            label="State"
            fullWidth
            autoComplete="State"
            variant="standard"
            value={addressDetails.State}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                State: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          {/* <TextField
            required
            id="Country"
            label="Country"
            fullWidth
            autoComplete="Country"
            variant="standard"
          /> */}
          <Autocomplete
            id="country-select-demo"
            sx={{ width: 250 }}
            options={countries}
            autoHighlight
            getOptionLabel={(option) => option.label}
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="20"
                  srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                  src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                  alt=""
                />
                {option.label} ({option.code}) +{option.phone}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Choose a country"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
                required
                value={addressDetails.Country}
                onChange={(e) =>
                  handleSetAddressDetails({
                    ...addressDetails,
                    Country: e.target.value,
                  })
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            id="PostalCode"
            label="PostalCode"
            fullWidth
            autoComplete="PostalCode"
            variant="standard"
            value={addressDetails.PostalCode}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                PostalCode: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            id="PanNo"
            label="PanNo"
            fullWidth
            autoComplete="PanNo"
            variant="standard"
            value={addressDetails.PanNo}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                PanNo: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            id="GSTNo"
            label="GSTNo"
            fullWidth
            autoComplete="GSTNo"
            variant="standard"
            value={addressDetails.GSTNo}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                GSTNo: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            id="AadharNo"
            label="AadharNo"
            fullWidth
            autoComplete="AadharNo"
            variant="standard"
            value={addressDetails.AadharNo}
            onChange={(e) =>
              handleSetAddressDetails({
                ...addressDetails,
                AadharNo: e.target.value,
              })
            }
          />
        </Grid>
        {/* <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox color="secondary" name="saveCard" value="yes" />}
            label="Remember credit card details for next time"
          />
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}
